module.exports = __webpack_public_path__ + "static/media/Arrival.7c13bea1.svg";